import axios from 'axios';

import { POPULATION_API_URL } from '../constants';

export default async function getPopulation() {
  try {
    const response = await axios(POPULATION_API_URL);
    return response.data;
  } catch (error) {
    console.log(`Failed to fetch population: ${error.message}`, error);
    return new Error(error);
  }
}
